import React from 'react'
import PropTypes from 'prop-types'
import { FormContext, useForm } from 'react-hook-form'

import useSnackbar from 'hooks/useSnackbar'
import usePermissions from 'hooks/usePermissions'
import useStyles from './styles'

import { ActivationCard } from './components'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'
import schema from './schema'

const ManageConfiguration = ({
  complaintConfiguration,
  setLoading,
  refresh,
  onSubmitSuccess,
}) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const permissions = usePermissions()

  const { COMPLAINT_CONFIG_DRIVER_STEP_2, COMPLAINT_CONFIG_DRIVER_STEP_3 } =
    constants.tours.complaint

  const notHasPermissionToManage =
    !permissions.permitted(
      constants.permissions.COMPLAINTS.MANAGE_CONFIGURATIONS,
    ) &&
    !permissions.permitted(constants.permissions.COMPLAINTS.ACTIVATE_COMPLAINTS)

  const methods = useForm({
    validationSchema: schema,
    defaultValues: {
      recurringEmail: complaintConfiguration?.recurringEmail || false,
      recurringEmailDays: complaintConfiguration?.recurringEmailDays || '',
      identification: complaintConfiguration?.identification || false,
    },
    mode: 'onChange',
  })

  const { handleSubmit } = methods

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.complaintConfigurations.manage({
        complaintConfigurations: data,
      })

      snackbar.open({
        message: 'Configurações foram salvas!',
        variant: 'success',
      })
      refresh()
      if (onSubmitSuccess) onSubmitSuccess()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error.response?.data?.error) ||
          'Aconteceu um erro ao salvar as configurações',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormContext {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
        id="manage-configuration-form"
      >
        <ActivationCard
          title="E-mail recorrente"
          label="Notificação recorrente de pendência de denúncias"
          description="Se esta opção estiver ativa, caso alguma denúncia fique sem resposta por um período de tempo, a plataforma irá enviar e-mails recorrentes de notificação para o(s) responsável(eis)."
          controlName="recurringEmail"
          detailsControlName="recurringEmailDays"
          disabled={notHasPermissionToManage}
          id={COMPLAINT_CONFIG_DRIVER_STEP_2}
        />
        <ActivationCard
          title="Identificação opcional do denunciante"
          label="Possibilitar a identificação opcional do denunciante"
          description="Se a opção de identificação estiver ativa, os dados do denunciante serão visíveis apenas internamente para a organização dentro da plataforma, garantindo sua privacidade."
          controlName="identification"
          disabled={notHasPermissionToManage}
          id={COMPLAINT_CONFIG_DRIVER_STEP_3}
        />
      </form>
    </FormContext>
  )
}

ManageConfiguration.propTypes = {
  complaintConfiguration: PropTypes.object,
  setLoading: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func,
}

export default ManageConfiguration
